export default () => {
  const init = () => {
    customElements.define("reset-password", ResetPassword);
  };
  init();
};

class ResetPassword extends HTMLElement{
  constructor() {
    super();
    this.validatePassword = this.validatePassword.bind(this);
    this.validateConfirmPassword = this.validateConfirmPassword.bind(this);
    this.translations = window.SS.Strings.errorsMessage;
  }
  
  connectedCallback(){
    this.initElements();
    this.initEventListeners();
  }

  initElements(){
    this.passwordInput = this.querySelector('#password') || null;
    this.confirmPasswordInput = this.querySelector('#password_confirmation') || null;
    this.passwordError = this.querySelector('#resetPasswordError') || null;
    this.confirmPasswordError = this.querySelector('#passwordConfirmationError') || null;
  }

  initEventListeners() {
    if (this.passwordInput) {
      this.passwordInput.addEventListener('input', () => this.validatePassword());
    }
    if (this.confirmPasswordInput) {
      this.confirmPasswordInput.addEventListener('input', () => this.validateConfirmPassword());
    }
  }

  disconnectedCallback() {
    if (this.passwordInput) {
      this.passwordInput.removeEventListener('input', () => this.validatePassword);
    }
    if (this.confirmPasswordInput) {
      this.confirmPasswordInput.removeEventListener('input', () => this.validateConfirmPassword);
    }
  }

  validateConfirmPassword() {
    const password = this.passwordInput.value.trim();
    const confirmPassword = this.confirmPasswordInput.value.trim();
    const isValid = password === confirmPassword;
  
    if (!isValid) {
      this.confirmPasswordError.textContent = this.translations.confirmPasswordErrorMessage;
      this.confirmPasswordInput.classList.add('error-message');
    } else {
      this.confirmPasswordError.textContent = '';
      this.confirmPasswordInput.classList.remove('error-message');
    }
  
    return isValid;
  }

  validatePassword() {
    const password = this.passwordInput.value.trim();
    const isValid = password.length >= 5;

    if (!isValid) {
      this.passwordError.textContent = this.translations.passwordErrorMessage;
      this.passwordInput.classList.add('error-message');
    } else {
      this.passwordError.textContent = '';
      this.passwordInput.classList.remove('error-message');
    }

    return isValid;
  }
};